import { createSlice } from '@reduxjs/toolkit';
import { initialFundCentreState as initialState } from './state';
import { setFundDetailsData } from './reducers';

export const fundCentreSlice = createSlice({
  name: 'fundCentre',
  initialState,
  reducers: {
    ...setFundDetailsData,
  },
});

export const fundCentreActions = fundCentreSlice.actions;
